import React, { useContext } from "react";
import { Navigate } from "react-router";
import { AuthContext, IntlContext, ListContext } from "context";
import { fetchFavorites } from "hooks/profile";
import { ListProvider, ListWrapper } from "components/List";
import type { AdInterface } from "types/ad";
import { Role } from "types/user";
import { ROUTES } from "routes";
import { AD_LIST_GRID_CLASS } from "app/OurAd/List/ComponentList";
import { FavoriteAdListCard } from "./FavoriteAdListCard";

const FavoriteAdsGrid: React.FC = () => {
    const { data } = useContext(ListContext);

    return (
        <div className={AD_LIST_GRID_CLASS}>
            {(data as AdInterface[]).map((ad) => (
                <FavoriteAdListCard key={ad.id} ad={ad} />
            ))}
        </div>
    );
};

const MyFavorites: React.FC = () => {
    const intl = useContext(IntlContext);
    const { currentRole } = useContext(AuthContext);

    if (currentRole !== Role.PROVIDER) {
        return <Navigate to={ROUTES.ACCOUNT_PROFILE} replace />;
    }

    return (
        <section className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="mb-6">
                <h2 className="text-xl font-bold text-slate-900">
                    {intl.formatMessage("profile.nav.my_favorites")}
                </h2>
                <p className="text-sm text-slate-500">
                    {intl.formatMessage("profile.my_favorites.description")}
                </p>
            </div>

            <ListProvider dataFetcher={fetchFavorites} cacheKey="favorites">
                <ListWrapper
                    ToolBarComponent={() => null}
                    noResultsLabel={intl.formatMessage("profile.my_favorites.empty")}
                    emptyStateClassName="rounded-xl bg-slate-50 p-4 text-sm text-slate-500"
                >
                    <FavoriteAdsGrid />
                </ListWrapper>
            </ListProvider>
        </section>
    );
};

export default MyFavorites;
